app.SiteDetailsView = app.BaseDetailsView.extend({
  // If countryCode is changed, force reload the timezone field view so it get a new list of
  // possible time zones for that country.
  _updateTimezoneSelection() {
    const fieldViews = this.fieldGroupView.fieldViewsByField;
    fieldViews.timezone.setValue(fieldViews.timezone.getValue(), fieldViews.timezone.model);
  },

  __fieldGroupDidChangeValue() {
    app.BaseDetailsView.prototype.__fieldGroupDidChangeValue.apply(this, arguments);

    this._updateTimezoneSelection();
  },
});
